const tabFilterWrap = $('.js-tabFilterWrap');
const filterTitleNum = $('.js-filterTitleNum');
const filterTitleOne = $('.js-filterTitleOne');
const filterTitle = $('.js-filterTitle');

$(document).on('click', '.js-tabFilter li', function() {

	const _this = $(this);
	const currentFiler = _this.data('filter');
	const tabs = _this.parents(tabFilterWrap).find('.tab');

	// для скролла к элементу в адаптиве
	const itemOuterWidth = _this.outerWidth(); // узнаем ширину текущего элемента (width + padding)
	const itemOffsetLeft = _this.offset().left; // узнаем значение отступа слева в контейнере у текущего элемента
	const containerScrollLeft = _this.parents('.js-tabOverflow').scrollLeft(); // узнаем текущее значение скролла
	const containerOuterWidth = _this.parents('.js-tabOverflow').outerWidth(); // узнаем ширину контейнера (width + padding)
	const positionCetner = (containerOuterWidth / 2 - itemOuterWidth / 2); // рассчитываем позицию центра
	const scrollLeftUpd = containerScrollLeft + itemOffsetLeft - positionCetner; // рассчитываем положение скролла относительно разницы отступа элемента и центра контейнера

	_this
		.addClass('active')
		.siblings()
		.removeClass('active')

	if (currentFiler == 'all') {
		tabs.show().addClass('tab_show');
		$('.tab_show').removeClass('first_tab last_tab');
	} else {
		tabs.each(function() {
			const thisElem = $(this);
			if (thisElem.data('type') == currentFiler) {
				thisElem.show().addClass('tab_show');
			} else {
				thisElem.hide().removeClass('tab_show');
			}
		});
	}

	filterTitleNum.text($('.tab_show').length);

	if ($('.tab_show').length == 1) {
		filterTitleOne.removeClass('is_hide');
		filterTitle.addClass('is_hide');
	} else {
		filterTitleOne.addClass('is_hide');
		filterTitle.removeClass('is_hide');
	}

	if ($('.js-tabOverflow')) {
		// анимируем
		_this.parents('.js-tabOverflow').animate({
			scrollLeft: scrollLeftUpd
		}, 400);
	}

	$('.tab_show').first().addClass('first_tab');
	$('.tab_show').last().addClass('last_tab');
});
